import { DateTime } from 'luxon'

import { Box, Comment as CommentBase, Text } from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import type { CommentModel } from '@models/comment'

import useComment from '@hooks/useComment'
import { useRelations as useUserRelations } from '@hooks/useUser'

const renderCommentBody = (comment: Partial<CommentModel>) => {
  const { body, data } = comment

  const templatePageId = digObject(data, 'template_page_id')
  if (templatePageId){
    return (
      <Box>
        <Text fontSize="xsmall">{body}</Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" fontStyle="italic" marginLeft="small">
          from Template Page #{templatePageId}
        </Text>
      </Box>
    )
  }

  return body
}

interface CommentProps {
  comment: Partial<CommentModel>,
  hideLastChildBottomBorder?: boolean,
}

const Comment = (props: CommentProps) => {
  const { comment, hideLastChildBottomBorder } = props

  const commentPayload = useComment(comment)
  const { comment: { public: isPublic }, user } = commentPayload

  const { image } = useUserRelations(user)

  const createdDateString = digObject(comment, 'dates.created.date_time')

  return (
    <CommentBase
      commentBody={renderCommentBody(comment)}
      commentTime={
        createdDateString
          ? DateTime.fromFormat(createdDateString, 'dd/MM/yyyy HH:mm').toFormat("ccc, dd LLL yyyy 'at' h:mm a")
          : 'Not Set'
      }
      fullName={user.full_name}
      hideLastChildBottomBorder={hideLastChildBottomBorder}
      imageUrl={image.thumb_url}
      isPublic={isPublic}
    />
  )
}

export default Comment
